import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Alarm/Object_Detection/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmLivestreamPerm';
import SettingsTable from 'components/Web_User_Interface/1440p_Series/Alarm/Object_Detection/settingsTable';
import YoutubeVideoCardAlarm from 'components/Web_User_Interface/1440p_Series/Alarm/Actions/YoutubeVideoCardAlarm';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Alarm Menu // Objekt Erkennung",
  "path": "/Web_User_Interface/1440p_Serie/Alarm/Objekt_Erkennung/",
  "dateChanged": "2022-11-08",
  "author": "Mike Polinowski",
  "excerpt": "Verwenden Sie das Menü Objekterkennung, um Ihr Videobild mit zwei Begrenzungsrahmen zu versehen. Der äußere Rahmen gibt die maximale Größe an, die ein erkanntes Objekt haben darf, um einen Alarm auszulösen. Der innere Rahmen definiert die Mindestgröße, die erforderlich ist, damit eine Erkennung als Alarm behandelt wird.",
  "image": "./WebUI_1440p_SearchThumb_Alarm_Object_Detection.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Alarm_Object_Detection.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Alarm Menu // Objekt Erkennung' dateChanged='2022-11-08' author='Mike Polinowski' tag='INSTAR IP Camera' description='Verwenden Sie das Menü Objekterkennung, um Ihr Videobild mit zwei Begrenzungsrahmen zu versehen. Der äußere Rahmen gibt die maximale Größe an, die ein erkanntes Objekt haben darf, um einen Alarm auszulösen. Der innere Rahmen definiert die Mindestgröße, die erforderlich ist, damit eine Erkennung als Alarm behandelt wird.' image='/images/Search/WebUI_1440p_SearchThumb_Alarm_Object_Detection.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Alarm_Object_Detection.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Alarm/Object_Detection/' locationFR='/fr/Web_User_Interface/1440p_Series/Alarm/Object_Detection/' crumbLabel="Object Erkennung" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "alarm-menu",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#alarm-menu",
        "aria-label": "alarm menu permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Alarm Menu`}</h2>
    <h3 {...{
      "id": "objekt-erkennung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#objekt-erkennung",
        "aria-label": "objekt erkennung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Objekt Erkennung`}</h3>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "einstellen-der-parameter-für-die-objekterkennung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#einstellen-der-parameter-f%C3%BCr-die-objekterkennung",
        "aria-label": "einstellen der parameter für die objekterkennung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Einstellen der Parameter für die Objekterkennung`}</h2>
    <p>{`Beachten Sie, dass die `}<strong parentName="p">{`Position des Begrenzungsrahmens nicht wichtig ist`}</strong>{`. Der Kamera-Schnappschuss im Hintergrund soll nur dabei helfen, die Größe der beiden Boxen zu bestimmen. Nur die Parameter Breite und Höhe der beiden Boxen werden verwendet, um Erkennungen zu filtern, die nicht zwischen diesen Mindest- und Höchstwerten liegen.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/282df3cbdf67102cb3aff62ff5a26723/610c0/1440p_Settings_Object_Detection_Bounding_Boxes.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.60869565217392%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAADf0lEQVQ4y32Sy29bdRCF/Z8kprUJcQq0EVVboeA4duP4cV++z9+9tmNfP5LYThw7JiFWid02AULLAqhABZUC4qGKl6iE1KRFCIRQN7BlyZ4tYvuhJG1FWbD4dOaMZjE6MwHl8j0ywzukL94lNbzL3GD/kORgn9mtBxzUg73DXmqwR2p4pOnhPunBPtnhHtbuTyRquwQarQ2aS2u4ooLn+BQcn6JTpuqVWfR8lvJVFr0qjUKdqlvDEXVMs4IQdXJGGSNfxyzUcf0GM0mJQOo5k/RpnblTKtlJGe10FnEuw0I8y5Yu8Y4nc8tXuO4oDJIq7ZhMdy7HumzT0i1cYSFsE9exmH5hikDsWY2pZyS8WJ2GWMdz2ghjBTVVJ37WJHZSoyUZ3L7Q5Odhk420Rz5bpjNn0TLzOJ5AkWVyukF0OkZAncohn1WpikWWG5tUxDIl0abgtUglXM48rRE7pbJTb/H7zT7v9tZQ4iU6syZNM49wBY5bwBJ5orE4gdhJlVLCYr26ypLfwTmvUchVaNXarJaK1FMa/nmb3aU8X3YLXJJzOFGDftqkljExTIucYWEYBtFolEBxVlBN2qzmG7xYbyNHs+QVn8Fyh7d783zUtfjuFY9fr1ncv1bges/lRk/w+YbJVjmHZQtsx8E0Taanpwlc9jzM5zVKao3NhRXOROIoiQLr/jLrusHOvM232xZ/3uvw150Wv71V4tPtKt+/WeTDK1UUVUO3XEzLPtqwl8nhTyv4aoWK2yI2mcFMzbPgLDCcd/hgzebrgc0f7xX4+4bDDy8JPt6p8NVOkfd3l3BcF13PYeg6MzMzBEpRncykgkj7NMprLLhtmoU2r66s8MWW4Fbf4rOewY8Xbe5fsvnmgs3tN+b55ZMGN6/WyekWIl/Cth3i8TgBK2mQOCdjpgW+W6FklaiJMl2/TL+o8XJZY1jVuNI2udqx2G6aDBd1Xu+adMsKUjpFVlWRDo5ykOFrLYVmUUFSVDRNQVVVVE1FUZXDfOR/ISkakqwiKxrZrIJaaKHXN2moFn1ZJXmQYb+SxbezZCTl8EHl/0F5DAnVW0ApdalJOdayEompKQLHxyYYG5/gxIkJIpEIoVDoMcLhEOGH+rA+9GFCx4KEnhghGAoxEg5z7PhxAuORCOORCcaeihB+coxgMPiI0dFRRkZGHul/OeiPjh7NBR/4fwC/3GjKjY4J5QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/282df3cbdf67102cb3aff62ff5a26723/e4706/1440p_Settings_Object_Detection_Bounding_Boxes.avif 230w", "/de/static/282df3cbdf67102cb3aff62ff5a26723/d1af7/1440p_Settings_Object_Detection_Bounding_Boxes.avif 460w", "/de/static/282df3cbdf67102cb3aff62ff5a26723/7f308/1440p_Settings_Object_Detection_Bounding_Boxes.avif 920w", "/de/static/282df3cbdf67102cb3aff62ff5a26723/42d56/1440p_Settings_Object_Detection_Bounding_Boxes.avif 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/282df3cbdf67102cb3aff62ff5a26723/a0b58/1440p_Settings_Object_Detection_Bounding_Boxes.webp 230w", "/de/static/282df3cbdf67102cb3aff62ff5a26723/bc10c/1440p_Settings_Object_Detection_Bounding_Boxes.webp 460w", "/de/static/282df3cbdf67102cb3aff62ff5a26723/966d8/1440p_Settings_Object_Detection_Bounding_Boxes.webp 920w", "/de/static/282df3cbdf67102cb3aff62ff5a26723/a8acc/1440p_Settings_Object_Detection_Bounding_Boxes.webp 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/282df3cbdf67102cb3aff62ff5a26723/81c8e/1440p_Settings_Object_Detection_Bounding_Boxes.png 230w", "/de/static/282df3cbdf67102cb3aff62ff5a26723/08a84/1440p_Settings_Object_Detection_Bounding_Boxes.png 460w", "/de/static/282df3cbdf67102cb3aff62ff5a26723/c0255/1440p_Settings_Object_Detection_Bounding_Boxes.png 920w", "/de/static/282df3cbdf67102cb3aff62ff5a26723/610c0/1440p_Settings_Object_Detection_Bounding_Boxes.png 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/282df3cbdf67102cb3aff62ff5a26723/c0255/1440p_Settings_Object_Detection_Bounding_Boxes.png",
              "alt": "Web User Interface - 1440p Serie - Objekterkennung Parameter",
              "title": "Web User Interface - 1440p Serie - Objekterkennung Parameter",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <SettingsTable mdxType="SettingsTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <EuiSpacer mdxType="EuiSpacer" />
    <YoutubeVideoCardAlarm mdxType="YoutubeVideoCardAlarm" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      